"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkKind = void 0;
exports.instanceOfNetworkKind = instanceOfNetworkKind;
exports.NetworkKindFromJSON = NetworkKindFromJSON;
exports.NetworkKindFromJSONTyped = NetworkKindFromJSONTyped;
exports.NetworkKindToJSON = NetworkKindToJSON;
exports.NetworkKindToJSONTyped = NetworkKindToJSONTyped;
/**
 *
 * @export
 */
exports.NetworkKind = {
    EMAIL: 'EMAIL',
    WEBSITE: 'WEBSITE',
    DISCORD: 'DISCORD',
    BATTLE_NET: 'BATTLE_NET',
    STEAM: 'STEAM',
    XBOX: 'XBOX',
    PLAYSTATION: 'PLAYSTATION',
    TWITTER: 'TWITTER',
    FACEBOOK: 'FACEBOOK',
    LINKEDIN: 'LINKEDIN',
    CHESS_COM: 'CHESS_COM',
    RIOT: 'RIOT',
    EPIC: 'EPIC',
    WIZARDS_OF_THE_COAST: 'WIZARDS_OF_THE_COAST',
    DOMINION_ONLINE: 'DOMINION_ONLINE',
    NINTENDO: 'NINTENDO',
    ORIGIN: 'ORIGIN',
    TETRIO: 'TETRIO',
    SUPERCELL: 'SUPERCELL',
    TWITCH: 'TWITCH',
    YOUTUBE: 'YOUTUBE',
    INSTAGRAM: 'INSTAGRAM',
    LOL_SUMMONER: 'LOL_SUMMONER',
    BOY_SCOUTS_OF_AMERICA: 'BOY_SCOUTS_OF_AMERICA',
    ID_ME: 'ID_ME',
    TIKTOK: 'TIKTOK',
    GARENA: 'GARENA',
    RIOT_VALORANT_AMERICAS: 'RIOT_VALORANT_AMERICAS',
    RIOT_VALORANT_EUROPE: 'RIOT_VALORANT_EUROPE',
    RIOT_VALORANT_ASIA: 'RIOT_VALORANT_ASIA',
    UNITY: 'UNITY',
    RALLY_CRY: 'RALLY_CRY',
    FROST_GIANT: 'FROST_GIANT',
    MASTERYCODING: 'MASTERYCODING',
    STREET_FIGHTER_ID: 'STREET_FIGHTER_ID',
    UBISOFT_ID: 'UBISOFT_ID',
    ACTIVISION_ID: 'ACTIVISION_ID'
};
function instanceOfNetworkKind(value) {
    for (var key in exports.NetworkKind) {
        if (Object.prototype.hasOwnProperty.call(exports.NetworkKind, key)) {
            if (exports.NetworkKind[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function NetworkKindFromJSON(json) {
    return NetworkKindFromJSONTyped(json, false);
}
function NetworkKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NetworkKindToJSON(value) {
    return value;
}
function NetworkKindToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
